import moment from 'moment';
let searchDate = moment().startOf().format('YYYYMMDD');

export default {
	authCode: '',
	partCost: [],
	gridList: [], //TableContainer의 그리드 data
	tymaCdList: [], //기종
	partGList:[],
	masterInfo: MASTER_INFO(), //masterInfo.vue data
	searchParams: SEARCH_PARAMS(), // 조회 data
	excelDownLoadList: [], //엑셀다운로드시 해더저장
	groups: GROUPS() // 페이징처리
};
function GROUPS() {
	return {
		currentPage: 1,
		pageUnit: 30,
		totalSize: 0
	};
}
function SEARCH_PARAMS() {
	return {
		stdDt: searchDate, //기준일
		partScn: 'PT', //부품구분(PT:일반부품,AS:AS부품)
		partNo: '', // 품번
		cpnyCd: '', //업체코드
		dlvgNm: '', //실납품사
		partG:''
	};
}

function MASTER_INFO() {
	return {
		partNo: '',
		partNm: '',
		cpnyCd: '',
		cpnyNm: '',
		aplPartCst: '',
		partCst: '',
		rtsh: '',
		strtDd: '',
		endDd: '',
		tymaCd: '',
		usePrd: '',
		milg: '',
		partG:''
	};
}
export { SEARCH_PARAMS, GROUPS, MASTER_INFO };
